import { render } from "./DiagnostForm.vue?vue&type=template&id=e48b881a&scoped=true"
import script from "./DiagnostForm.vue?vue&type=script&lang=js"
export * from "./DiagnostForm.vue?vue&type=script&lang=js"

import "./DiagnostForm.vue?vue&type=style&index=0&id=e48b881a&scoped=true&lang=css"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48b881a"]])

export default __exports__